import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

const selectReferralState = (state: RootState) => state.referral;

const selectReferralSummary = createDraftSafeSelector(
  selectReferralState,
  (state) => state.summary,
);

const selectReferralLoading = createDraftSafeSelector(
  selectReferralState,
  (state) => state.loading,
);

export { selectReferralState, selectReferralSummary, selectReferralLoading };
